import React, { useState, useEffect } from 'react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 bg-gradient-to-r from-blue-400 via-blue-300 to-secondary backdrop-blur-md shadow-lg transition-all duration-300 w-full ${scrolled ? 'py-2' : 'py-4'}`}>
      <div className="flex flex-col items-center justify-between w-full gap-2 px-4 mx-auto max-w-7xl sm:px-6 sm:flex-row sm:gap-4">
        <div className="text-center sm:text-left">
          <h1 className="text-xl font-bold text-transparent text-white sm:text-2xl bg-gradient-to-r from-blue-400 via-blue-300 to-secondary bg-clip-text">yabu</h1>
          <p className="mt-1 text-xs text-gray-300 sm:text-sm">Student Engineer</p>
        </div>

        <nav>
          <ul className="flex flex-wrap justify-center gap-1 sm:gap-2">
            <li><a href="#about" className="text-white text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg hover:bg-white/10 transition-all duration-300 font-medium relative overflow-hidden group">
              <span className="relative z-10">About</span>
            </a></li>
            <li><a href="#skills" className="text-white text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg hover:bg-white/10 transition-all duration-300 font-medium relative overflow-hidden group">
              <span className="relative z-10">Skills</span>
            </a></li>
            <li><a href="#projects" className="text-white text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg hover:bg-white/10 transition-all duration-300 font-medium relative overflow-hidden group">
              <span className="relative z-10">Projects</span>
            </a></li>
            <li><a href="#news" className="text-white text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg hover:bg-white/10 transition-all duration-300 font-medium relative overflow-hidden group">
              <span className="relative z-10">News</span>
            </a></li>
            <li><a href="#contact" className="text-white text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg hover:bg-white/10 transition-all duration-300 font-medium relative overflow-hidden group">
              <span className="relative z-10">Contact</span>
            </a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
